import {FeatureModel} from '../../api/feature-model';

export class UserAppFeatureModel {
  feature: FeatureModel;

  // tslint:disable-next-line:variable-name
  private _allowed = false;

  get allowed(): boolean {
    return this._allowed;
  }

  set allowed(value: boolean) {
    const oldValue = this._allowed;

    if (oldValue === value) { return; }

    this._allowed = value;

    if (this.allowedOnChange) {
      this.allowedOnChange();
    }
  }
  allowedOnChange?: () => void;
}
